import { render, staticRenderFns } from "./SideBarTradingChart.vue?vue&type=template&id=e7c9abf4&"
import script from "./SideBarTradingChart.vue?vue&type=script&lang=js&"
export * from "./SideBarTradingChart.vue?vue&type=script&lang=js&"
import style0 from "./SideBarTradingChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports